import { hasVariant, isFeatureActive } from '../../selectors/configSelectors';
import { MVT_1146 } from '../../flags/experiments';
import { CO_WEB_SEARCH_EMPLOYEES } from '../../flags/features';

const isHomeSearchActive = (state) =>
  hasVariant(state, MVT_1146, 'feature') || isFeatureActive(state, CO_WEB_SEARCH_EMPLOYEES);

export default isHomeSearchActive;
